var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu", class: _vm.isMenuOpened ? "menu_opened" : "" },
    [
      _c("div", { staticClass: "menu__app" }, [
        _c(
          "div",
          {
            ref: "menuMainContainer",
            staticClass: "menu__container",
            class: [
              _vm.hideMenu ? "menu__container_hidden" : "",
              _vm.menuColor,
            ],
          },
          [
            _c("div", { staticClass: "menu__arrow menu__arrow-top" }, [
              this.activeLink !== null && this.activeLink.id !== 0
                ? _c("div", {
                    domProps: {
                      innerHTML: _vm._s(require("../img/menuArrow.svg")),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onGoNext(-1)
                      },
                    },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu__transform-container",
                style: { height: _vm.transformWrapperHeight },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "menu__transform-wrapper",
                    style: { transform: _vm.transformContainer3D },
                  },
                  _vm._l(_vm.links, function (link) {
                    return _c("a", {
                      ref: "menuLink" + link.id,
                      refInFor: true,
                      staticClass: "menu__item",
                      class: [_vm.linkClass(link)],
                      attrs: { href: link.sectionId },
                      domProps: { innerHTML: _vm._s(_vm.$t(link.text)) },
                      on: {
                        click: function ($event) {
                          return _vm.onClick(link, $event)
                        },
                      },
                    })
                  }),
                  0
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "menu__arrow menu__arrow-bottom" }, [
              this.activeLink === null ||
              (this.activeLink !== null &&
                this.activeLink.id < this.links.length - 1)
                ? _c("div", {
                    domProps: {
                      innerHTML: _vm._s(require("../img/menuArrow.svg")),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onGoNext(1)
                      },
                    },
                  })
                : _vm._e(),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }